import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import styles from "./DispatchSearch.module.css";
import t from "../../utils/translation";

const DispatchSearch = ({
  cycleQuery,
  handleCycleQueryChange,
  handleFocus,
  handleKeyDown,
  inputRef,
  searchLocked,
  selectedSterilizer,
  handleSearchClick,
  isFocused,
  suggestions,
  suggestionsRef,
  activeSuggestionIndex,
  handleSuggestionClick,
  loading
}) => {
  return (
    <div className={styles.searchContainer}>
      <FaSearch className={styles.searchIcon} />
      <input
        ref={inputRef}
        type="text"
        placeholder={loading ? `${t("Loading")}` : ""}
        value={cycleQuery}
        onChange={handleCycleQueryChange}
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
        className={styles.searchInput}
        disabled={searchLocked || !selectedSterilizer || loading}
      />
      <button
        className={`${styles.searchActionButton} ${
          searchLocked ? styles.cancelButton : styles.searchButton
        }`}
        onClick={handleSearchClick}
        disabled={!selectedSterilizer}
      >
        {searchLocked ? (
          <>
            <FaTimes className={styles.buttonIcon} />
            {t("Cancel")}
          </>
        ) : (
          <>
            <FaSearch className={styles.buttonIcon} />
            {t("BlankEntry117")}
          </>
        )}
      </button>
      {!searchLocked && isFocused && suggestions.length > 0 && (
        <div className={styles.autocompleteSuggestions} ref={suggestionsRef}>
          {suggestions.map((sugg, index) => (
            <div
              id={`suggestion-${index}`}
              key={sugg.chargeId}
              className={`${styles.suggestionItem} ${
                index === activeSuggestionIndex ? styles.activeSuggestion : ""
              }`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSuggestionClick(sugg)}
            >
              {sugg.cycleNumber}
              {/* poner cicle solo para lavado */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DispatchSearch;
